import {Component, OnInit} from '@angular/core';
import {AuthService} from "./data/services/modules/auth/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PrimeNGConfig} from "primeng/api";
import {PushingService} from "./data/services/api/flow/pushing.service";
import {LoaderService} from "./modules/private/verify-information/data/services/page/loader.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pulpi-v4-app';
  showLeftMenu = false

  constructor(
    public authService: AuthService,
    public loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private config: PrimeNGConfig,
    private pushingService: PushingService
  ) {
    this.config.setTranslation({
      startsWith: 'Empieza con',
      contains: 'Contiene',
      notContains: 'No contiene',
      endsWith: 'Acaba en',
      equals: 'Igual',
      notEquals: 'No igual',
      noFilter: 'Sin filtro',
      lt: 'Menor que',
      matchAll: 'Coincide con todos',
      matchAny: 'Coincide con cualquiera',
      dateIs: 'La fecha es',
      dateIsNot: 'La fecha no es',
      dateAfter: 'La fecha es despues de',
      dateBefore: 'La fecha es antes de',
      addRule: 'Agregar regla',
      clear: 'Limpiar',
      apply: 'Aplicar',
      gt: 'Mayor que',
      gte: 'Mayor o igual que',
      lte: 'Menor o igual que',
      weak: 'Debil',
      medium: 'Aceptable',
      strong: 'Fuerte',
      passwordPrompt: 'Ingresa una contraseña',
      // Calendario y listas en español (p-calendar, p-dropdown con filtro).
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      firstDayOfWeek: 1,
      today: 'Hoy',
      weekHeader: 'Sem',
      choose: 'Elegir',
      upload: 'Subir',
      cancel: 'Cancelar',
      accept: 'Aceptar',
      reject: 'Cancelar',
      emptyMessage: 'Sin opciones',
      emptyFilterMessage: 'Sin resultados',
      searchMessage: '{0} resultados disponibles',
      selectionMessage: '{0} elementos seleccionados',
      emptySelectionMessage: 'Ningún elemento seleccionado',
      emptySearchMessage: 'Sin resultados',
      pending: 'Pendiente',
      chooseYear: 'Elegir año',
      chooseMonth: 'Elegir mes',
      chooseDate: 'Elegir fecha',
      prevDecade: 'Década anterior',
      nextDecade: 'Década siguiente',
      prevYear: 'Año anterior',
      nextYear: 'Año siguiente',
      prevMonth: 'Mes anterior',
      nextMonth: 'Mes siguiente',
      aria: {
        trueLabel: 'Sí',
        falseLabel: 'No',
        nullLabel: 'Sin seleccionar',
        close: 'Cerrar',
        previous: 'Anterior',
        next: 'Siguiente',
        navigation: 'Navegación',
        prevPageLabel: 'Página anterior',
        nextPageLabel: 'Página siguiente',
        selectRow: 'Seleccionar fila',
        unselectRow: 'Quitar selección'
      }
    })
  }
}
